module.exports = __webpack_public_path__ + "img/202312_01.6cf376e9.jpg";